import axios from 'axios';
import { LicensingApplication } from '@resources/scripts/models';

export const create = async payload => axios.post('/api/licensingapplications/', payload);
export const getById = async (id: number) => axios.get(`/api/licensingapplications/${id}`);
export const update = async (id: number, application: LicensingApplication) => axios.patch(`/api/licensingapplications/${id}`, application);
export const associateTransaction = async (id: number, transactionId: number) => axios.post(`/api/licensingapplications/${id}/associate-transaction?transactionId=${transactionId}`);

export default {
  create,
  getById,
  update,
  associateTransaction,
};